import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';
import { cn } from '../../utils/cn';

/**
 * CountryFlag — drapeau SVG d'un pays (ISO-2).
 *
 *   <CountryFlag code="FR" />
 *
 * Utilise country-flag-icons (SVG, pas de Unicode). Le bundle inclut
 * tous les drapeaux mais ils sont petits et seuls les composants
 * effectivement rendus dans le DOM consomment du runtime.
 *
 * Props :
 *   - code     : ISO-3166-1 alpha-2 (ex: "FR", "BE", "RE"). Insensible à la casse.
 *   - size     : 'xs' | 'sm' | 'md' | 'lg' — hauteur du drapeau (ratio 3:2)
 *   - rounded  : bord arrondi (default true)
 *   - title    : tooltip natif (default = code)
 */

const SIZES = {
  xs: 'h-2.5 w-[15px]',
  sm: 'h-3   w-[18px]',
  md: 'h-3.5 w-[21px]',
  lg: 'h-4   w-6',
};

export function CountryFlag({
  code,
  size = 'sm',
  rounded = true,
  title,
  className,
  ...rest
}) {
  if (!code) return null;
  const normalized = String(code).toUpperCase();
  const FlagComp = Flags[normalized];

  const sizeCls = SIZES[size] || SIZES.sm;
  const sharedCls = cn(
    'inline-block shrink-0 select-none',
    sizeCls,
    rounded && 'rounded-[2px] ring-1 ring-ink/8',
    className,
  );

  if (!FlagComp) {
    return (
      <span
        className={cn(
          'inline-flex items-center justify-center text-[8px] font-mono font-semibold text-mute bg-bg-2',
          sizeCls,
          rounded && 'rounded-[2px] ring-1 ring-ink/8',
          className,
        )}
        title={title || normalized}
        aria-label={title || normalized}
        {...rest}
      >
        {normalized}
      </span>
    );
  }

  return (
    <FlagComp
      title={title || normalized}
      className={cn(sharedCls, 'object-cover')}
      {...rest}
    />
  );
}

export default CountryFlag;
